import type { FC } from "react";
import Button from "../../../Button";
import type { FlagType } from "../../../Flag/Flag";
import type { IconType } from "../../../Icon/Icon";
import * as s from "./GlobalLink.module.scss";

type GlobalLinkProps = {
	icon: IconType | FlagType;
	label: string;
	href?: string;
	target?: string;
	onClick?: () => void;
};

const GlobalLink: FC<GlobalLinkProps> = ({
	icon,
	label,
	href,
	target,
	onClick,
}) => {
	return (
		<li className={s.listItem}>
			<Button
				variant="noBg"
				label={label}
				icon={icon}
				iconLeft
				{...(href ? {} : { onClick: onClick })}
				href={href}
				target={target}
				className={s.cta}
			/>
		</li>
	);
};
export default GlobalLink;
